import { render, staticRenderFns } from "./StatsCardCustom.vue?vue&type=template&id=a8667114&scoped=true&"
import script from "./StatsCardCustom.vue?vue&type=script&lang=js&"
export * from "./StatsCardCustom.vue?vue&type=script&lang=js&"
import style0 from "./StatsCardCustom.vue?vue&type=style&index=0&id=a8667114&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8667114",
  null
  
)

export default component.exports